import { useModal } from 'modals';

import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';

import { pageFrame } from '../page-frame';
import ModelIntro from './ModelIntro';
import {
  ActionCard,
  CapabilityCard,
  ModelCard,
  SectionLabel,
} from './components';
import { swingContent } from './content';

export default function SwingPage() {
  const { open } = useModal();

  return (
    <div className={pageFrame}>
      <ModelIntro intro={swingContent.intro} model="swing" />
      <section className="border-primary flex flex-col gap-10 border-b px-4 py-10 sm:gap-20 sm:px-12 sm:py-20">
        <SectionLabel>Models</SectionLabel>
        <div className="grid gap-6 md:grid-cols-2">
          {swingContent.models.map((card) => (
            <ModelCard key={card.id} card={card} />
          ))}
        </div>
      </section>
      <section className="border-primary border-b px-4 py-20 sm:px-12">
        <Text
          as="h2"
          token={{
            base: 'display/32/bold',
            sm: 'display/56/bold',
            xl: 'display/88/bold',
          }}
          leading="headline"
          className="max-w-[1320px] text-pretty"
        >
          Human motion on demand,{' '}
          <span className="text-green">at any scale</span>
        </Text>
      </section>
      <section className="border-primary flex flex-col gap-10 border-b px-4 py-10 sm:gap-20 sm:px-12 sm:py-20">
        <SectionLabel>Capabilities</SectionLabel>
        <div className="grid grid-cols-2 gap-6 min-[520px]:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
          {swingContent.capabilities.map((capability) => (
            <CapabilityCard
              key={capability.id}
              capability={capability}
              mediaClassName="aspect-video"
            />
          ))}
        </div>
      </section>
      <section className="border-primary flex flex-col gap-10 border-b px-4 py-10 sm:gap-20 sm:px-12 sm:py-20">
        <div className="flex max-w-[813px] flex-col gap-10">
          <SectionLabel>{swingContent.action.title}</SectionLabel>
          <Text
            as="p"
            token={{ base: '16', sm: '32' }}
            leading="body"
            className="text-secondary text-pretty"
          >
            {swingContent.action.description}
          </Text>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
          {swingContent.action.cards.map((card) => (
            <ActionCard key={card.id} {...card} size="swing" />
          ))}
        </div>
        <article className="bg-secondary flex min-h-[259px] flex-col items-start gap-10 rounded-2xl p-8">
          <Text as="h3" token={{ base: '16', sm: '32' }} leading="body">
            {swingContent.action.custom.title}
          </Text>
          <Text
            as="p"
            token={{ base: '16', sm: '32' }}
            leading="body"
            className="text-secondary max-w-[784px] text-pretty"
          >
            {swingContent.action.custom.description}
          </Text>
          <Button
            type="button"
            variant="cta"
            onClick={() =>
              open('ENTERPRISE_CONTACT', { reason: 'pilot_cartwheel' })
            }
          >
            {swingContent.action.custom.action}
          </Button>
        </article>
      </section>
    </div>
  );
}
